import { render, staticRenderFns } from "./PhotoIcon.vue?vue&type=template&id=ffef1a06&"
import script from "./PhotoIcon.vue?vue&type=script&lang=js&"
export * from "./PhotoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports